import { render, staticRenderFns } from "./Administrative.vue?vue&type=template&id=038870a4&scoped=true&"
import script from "./Administrative.vue?vue&type=script&lang=js&"
export * from "./Administrative.vue?vue&type=script&lang=js&"
import style0 from "./Administrative.vue?vue&type=style&index=0&id=038870a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038870a4",
  null
  
)

export default component.exports